// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._12extv0 {
  color: var(--_18w76bw2g);
  flex-basis: 100%;
}
._12extv0:hover {
  text-decoration: underline;
  color: var(--_18w76bw2q);
}
@media screen and (min-width: 768px) {
  ._12extv0 {
    flex-basis: calc(50% - 10px);
  }
}
@media screen and (min-width: 1024px) {
  ._12extv0 {
    flex-basis: calc(33% - 10px);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["._12extv0 {\n  color: var(--_18w76bw2g);\n  flex-basis: 100%;\n}\n._12extv0:hover {\n  text-decoration: underline;\n  color: var(--_18w76bw2q);\n}\n@media screen and (min-width: 768px) {\n  ._12extv0 {\n    flex-basis: calc(50% - 10px);\n  }\n}\n@media screen and (min-width: 1024px) {\n  ._12extv0 {\n    flex-basis: calc(33% - 10px);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
